import { smStyle } from '@/components/Adapter'
import styled from 'styled-components'

export const SearchWrapStyled = styled.div`
  width: 100%;
`

export const SearchListStyled = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 0 6px 0 8px;
  max-height: calc(80vh - 49px - 52px);

  ${smStyle} {
    max-height: 360px;
  }
`

export const SearchItemStyled = styled.a`
  width: 100%;
  padding: 10px 8px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background: var(--color-neutral-2);
  }

  .currency-price {
    max-width: 50vw;

    ${smStyle} {
      max-width: 100px;
    }
  }
`
